import { localStorageHelper } from './localStorage';

const AUTH_KEYS = ['token', 'type', 'role'];

export const setAuthMeta = ({ type, role }) => {
  if (type) localStorageHelper.setItem('type', type);
  if (role) localStorageHelper.setItem('role', role);
};

export const clearAuthStorage = () => {
  AUTH_KEYS.forEach(key => localStorageHelper.removeItem(key));
};

export const getAuthType = () => localStorageHelper.getItem('type');

export const getAuthRole = () => localStorageHelper.getItem('role');
